var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"icon-left":"school","size":_vm.size,"expanded":_vm.expanded,"tag":"a","href":_vm.href,"target":"_blank"}},[_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }